module.exports = fox._r("images/messages-hover.png", __webpack_public_path__ + "images/messages-hover.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/messages-hover.png
// module id = 1082
// module chunks = 4